import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import ConfigurationActions from '../../redux/configurationRedux';
import { isNil } from '../../services/helper';
import style from '../scenes.scss';

// Components
import BasicModelBox from '../../components/selectionBoxes/basicModelBox/basicModelBoxComponent';

class BasisModelScene extends Component {
    constructor(props) {
        super(props);

        this.state = {
            refreshing: false,
            selectedModel: null,
        };
    }

    setActiveItem = () => {
        const { configuration } = this.props;
        if (!isNil(configuration.model)) {
            this.setState({ selectedModel: configuration.model.id });
        }
    }

    componentDidMount() {
        this.setActiveItem();
    }

    renderCaravanModels = () => {
        const { configuration } = this.props;
        const { caravan } = configuration;
        if (isNil(caravan)) {
            return null;
        }

        const onSelectBox = (model) => {
            if (!isNil(model)) {
                this.props.setModel(model);
                this.setState({ selectedModel: model.id });
                this.props.setRefreshing(true);
            }
        };

        const models = caravan.models;
        const listItems = models.map((modelItem, index) =>
            // eslint-disable-next-line max-len
            <BasicModelBox key={index} model={modelItem} selectedModel={this.state.selectedModel} onSelectBox={(model) => onSelectBox(model)} />
        );

        return (
            <div className={style.form_container}>
                {listItems}
            </div>
        );
    }

    render() {
        return (
            <div className={style.scene}>
                <div className={style.title}>
                    <h2>{t`Grundmodell wählen`}</h2>
                </div>

                <form>
                    {this.renderCaravanModels()}
                </form>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    caravans: state.caravans.caravans,
    configuration: state.configuration,
});

const mapDispatchToProps = dispatch => ({
    setModel: (model) =>
        dispatch(ConfigurationActions.setModel(model)),
    setRefreshing: (refresh) =>
        dispatch(ConfigurationActions.setRefreshing(refresh)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BasisModelScene);
